//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MipLightbox from '@/components/clinicToast/mipLightbox'
import PlanDetailsToast from '@/components/planDetailsToast'
import { FactoryUtils } from "@/utils/FactoryUtils"    
import problem from '@/components/layer/problem'
import insureDetails from '@/components/layer/insureDetails'
import secondary from '@/components/layer/secondary'
import contentInfo from '@/components/layer/contentInfo'

export default {
    name: "de",
    data(){
        return {
          product:[],
          serverTips:1,
          imgList:[],
          moreHotList:[],
        }
    },
    props: {
        templateFlag:{
            type: String,
            default:''
        },
        qybFlag: {
            type: Boolean,
            default() { return true}
        },
        productListImg:{
            type: Array,
            default() { return []}
        }
    },
    watch: {
        productListImg(val){
            if(this.productList.length > 1){
                this.imgList =this.productListImg
            }
        }
    },
    created () {
        FactoryUtils.productDetails().then(res =>{
          this.product = res.productList;
          if(this.productListImg.length > 1){
            console.log('this.productListImg',this.productListImg)
            this.imgList =this.productListImg
          }else{
            this.imgList = res.imgList;
          }
          this.moreHotList = res.moreHotList;
          if(!this.qybFlag){
            this.imgList.pop()
          }
        })
        
    },
    components:{
      MipLightbox,
      PlanDetailsToast,
      problem,
      insureDetails,
      secondary
    },
    methods:{
      skip(name){
          console.log(name)
          this[name]();
      },
      zjlufu(){ // 重疾绿通
        this.STATISTICS('click','sybao_ins_proinfo_greenchannel_click')
        this.serverTips = 1 ;
        this.$refs.insuerDetailsRef.showToast()

      },
      mil(){ // 100种重大疾病
        this.STATISTICS('click','sybao_ins_proinfo_disease_click')
        this.serverTips = 2 ;
           this.$refs.insuerDetailsRef.showToast()

      },
        helpClick(){ //查看全部问题
            if(this.moreHotList.length){
                 this.$refs.problemRef.showToast()
            }else{
                this.$router.push({
                    path: "/helpList",
                    query:{
                        'templateFlag':this.templateFlag
                    }
                });
            }
            
            this.STATISTICS('click','sybao_ins_proinfo_problems_click')
            
            
        },
        hostList(){
          if(this.$route.path == "/qybActivity"){
            this.STATISTICS('click','sybao_ins_qybactivity20191111_first_clinic_click')
          }else if(this.$route.path == "/details"){
            this.STATISTICS('click','sybao_ins_proinfo_allclinic_click')
          }

            this.$refs.mipLightbox.showToast()
        },
        project(){
          if(this.$route.path == "/qybActivity"){
            this.STATISTICS('click','sybao_ins_qybactivity20191111_first_allproject_click')

          }
            this.$router.push({
                    path: "/projectDetails",
                });
        },
        planToast(){
           if(this.$route.path == "/details"){
            this.STATISTICS('click','sybao_ins_proinfo_ensuredetail_click')
          }
            this.$refs.planDetails.showToast()
        },
        planDetails(){
            this.$router.push({
                    path: "/planDetails",
                    query:{
                        'templateFlag':'ht_cc'
                    }
                });
        },
        askClick(e){
            if(this.product[e].flag){
                this.product[e].flag=false
            }else{
              //展开问题 记录统计                    
              this.STATISTICS('click','sybao_ins_proinfo_problem_click')
              this.product[e].flag=true
            }
        },
        hospitalsClick(){ //点击服务医院表
         this.STATISTICS('click','sybao_ins_greenchannel_hospitals_click')
       },  
    }
}
